import { render, staticRenderFns } from "./ComissaoFuneraria.vue?vue&type=template&id=191b6176&scoped=true"
import script from "./ComissaoFuneraria.vue?vue&type=script&lang=js"
export * from "./ComissaoFuneraria.vue?vue&type=script&lang=js"
import style0 from "./ComissaoFuneraria.vue?vue&type=style&index=0&id=191b6176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b6176",
  null
  
)

export default component.exports